<template>
  <div class="home-container my-auto">

    <div class="home-header">
      <div class="home-logo"><img src="@/assets/img/logo.png"></div>
      <div class="col-md-12 header-title">Espace candidat</div>
      <div class="col-md-12 header-text">Nous éprouvons actuellement des difficultés pour vous permettre d'accéder à cette ressource.
        <div class="col-md-12 header-subtext">Merci de bien vouloir patienter et réessayer ultérieurement.</div>
      </div>
    </div>

    <div class="home-login-group">
      <button class="btn btn-primary btn-block" @click="login">
        <span>Se connecter</span>
      </button>

      <div class="home-login-group-info">Pas encore inscrit ?</div>
      <div class="home-login-group-href">
        <router-link :to="{ name: 'public-register-approach'}" class="nav-link">
          Créer un compte
        </router-link>
      </div>
      <div class="home-login-group-help">
        <router-link :to="{ name: 'public-help-candidature'}" target="_blank">Aide à la candidature</router-link>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "Maintenance",
  data() {
    return {
      content: "",
    };
  },
  methods: {
    login: function () {
      this.$router.push({name: 'public-login'});
    }
  },
};
</script>
